import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { notify } from '../../../toaster';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { QUERY_KEY_COLLECTION_ITEMS } from './useGetCollectionItems';

export const useDeleteCollectionItem = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: async (params: {
      id: number;
      hideNotification?: boolean;
      type: 'card' | 'dashboard';
    }) => {
      const response = await metabaseApi.delete(
        `${METABASE_API_URL}/${params.type}/${params.id}`
      );
      return response;
    },
    onSuccess: (_, variables) => {
      if (!variables.hideNotification) {
        notify.default({
          title: intl.formatMessage(
            { id: 'features.reporting.deleteNotification.itemRemoved' },
            {
              itemType: intl.formatMessage({
                id: `features.reporting.itemType.${variables.type}`,
              }),
            }
          ),
        });
      }
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_COLLECTION_ITEMS],
      });
    },
    onError: (_, variables) => {
      notify.error({
        title: intl.formatMessage(
          { id: 'features.reporting.deleteNotification.itemRemovalFailed' },
          {
            itemType: intl.formatMessage({
              id: `features.reporting.itemType.${variables.type}`,
            }),
          }
        ),
      });
    },
  });
};
